import { useMutation } from "react-query";
import { deleteDoorBuzzer } from "../../../../actions/CarrierAgreementMgmt/Security";

const useDeleteDoorBuzzer = () => {
  return useMutation(deleteDoorBuzzer);
};
export default useDeleteDoorBuzzer;
